'use client';
import { createBrowserClient } from '@supabase/ssr';
import { Database } from '../types/database.types';

// Create a Supabase client for use in client components
// This client automatically handles authentication and includes the JWT token in requests
export const supabase = createBrowserClient<Database>(
  process.env.NEXT_PUBLIC_SUPABASE_URL!,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
);
